export interface DuplicateScanGuard {
  // The ms since the same code passed in the window, or null after the code
  // passes and the guard records it.
  check(code: string): number | null;
  reset(): void;
}

const DEFAULT_DUPLICATE_PREVENTION_WINDOW_MS = 3000;

export function createDuplicateScanGuard(
  windowMs = DEFAULT_DUPLICATE_PREVENTION_WINDOW_MS,
  now: () => number = () => Date.now()
): DuplicateScanGuard {
  let lastCode: string | null = null;
  let lastAt = 0;
  return {
    check(code) {
      const at = now();
      if (code === lastCode && at - lastAt < windowMs) return at - lastAt;
      lastCode = code;
      lastAt = at;
      return null;
    },
    reset() {
      lastCode = null;
      lastAt = 0;
    },
  };
}
